<template>
    <button class="icon-btn" type="button" aria-label="details" @click="toggleDetails" v-touch:touchhold="goToDetails" >
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none"> <path d="M12 11.5V16.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 7.51L12.01 7.49889" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> <path d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/> </svg>

        <transition name="fade">
            <portal to="wod-overlay">
                <div class="expanded-details-modal" v-if="showDetails">
                    <div class="backdrop" @click.stop="toggleDetails"> </div>
                    <div class="details-wrapper">
                        <OnDemandDetails
                            v-if="mode==='od'"
                            :contentType="type"
                            :contentId="id"
                            :embeded="true"
                            :detailsOnly="true"
                        />

                        <Channel
                            v-if="mode==='live'"
                            :contentId="id"
                            :embeded="true"
                            :detailsOnly="true"
                        />

                        <EPG
                            v-if="mode==='epg'"
                            :contentId="id"
                            :embeded="true"
                            :detailsOnly="true"
                        />

                        <Game
                            v-if="mode==='game'"
                            :contentId="id"
                            :embeded="true"
                            :detailsOnly="true"
                        />

                        <Sport
                            v-if="mode==='sport'"
                            :contentId="id"
                            :contentLeague="league"
                            :contentSport="kind"
                            :embeded="true"
                            :detailsOnly="true"
                        />

                    </div>
                </div>
            </portal>
        </transition>

    </button>
</template>

<script>

const OnDemandDetails = () => import("@/views/Details.vue");
const Channel = () => import("@/views/Channel.vue");
const EPG = () => import("@/views/Guide.vue");
const Game = () => import("@/views/Game.vue");
const Sport = () => import("@/views/Sport.vue");

export default {
    name: 'GTS',
    components: {
        OnDemandDetails,
        Channel,
        EPG,
        Game,
        Sport

    },
    props: {
        mode: String,
        type: String,
        kind: String,
        league: String,
        id: String
    },
    computed: { },
    data() {
        return{
            showDetails: false
        }
    },
    methods: {
        toggleDetails(){
            this.showDetails = !this.showDetails
        },
        goToDetails(){
            let path = ''

            if(this.mode === 'od'){
                path = `/${this.type}/${this.id}`
            }

            if(this.mode === 'live'){
                path = `/channel/${this.id}`
            }

            if(this.mode === 'epg'){
                path = `/guide/${this.id}`
            }

            if(this.mode === 'sport'){
                path = `/sport/${this.kind}/${this.league}/${this.id}`
            }
            if(this.mode === 'game'){
                path = `/game/${this.id}`
            }


            window.open(path, '_blank')

        }
    },
}
</script>

<style lang="scss" scoped>
</style>
